// import hooks
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { TabProps } from '../CLASettings.types';

//import utils
import {
  deviatingReimbAttandanceFields,
  deviatingReimbAttandanceFieldsOnCall
} from '../CLASettings.consts';
import { deviatingReimbAttandanceSchema } from '../CLASettings.schema';

//import components
import Grid from '@mui/material/Grid';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

const ControlledNumericFieldWithReadMode = withReadModeField(
  ControlledNumericField
);

const DeviatingTab = ({ setCurrentSchema }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });

  useEffect(() => {
    setCurrentSchema(deviatingReimbAttandanceSchema);
  }, []);

  return (
    <div style={{ paddingBottom: 60 }}>
      <MultiStepForm.Section title={t('deviatingReimbAttandance')}>
        <Grid
          container
          spacing={{ compact: 2, medium: 3 }}
          columns={{ compact: 4, medium: 8, large: 12 }}
        >
          {deviatingReimbAttandanceFields.map((item, id) => (
            <Grid
              key={`deviatingReimbAttandance_grid_${id}`}
              sx={{
                compact: 2,
                medium: 4,
                expanded: 4
              }}
            >
              <ControlledNumericFieldWithReadMode
                key={`deviatingReimbAttandance_${id}`}
                name={item.name}
                label={t(item.label)}
                variant="outlined"
              />
            </Grid>
          ))}
        </Grid>
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('deviatingReimbOnCall')}>
        <Grid
          container
          spacing={{ compact: 2, medium: 3 }}
          columns={{ compact: 4, medium: 8, large: 12 }}
        >
          {deviatingReimbAttandanceFieldsOnCall.map((item, id) => (
            <Grid
              key={`deviatingReimbOnCall_grid_${id}`}
              sx={{
                compact: 2,
                medium: 4,
                expanded: 4
              }}
            >
              <ControlledNumericFieldWithReadMode
                key={`deviatingReimbOnCall_${id}`}
                name={item.name}
                label={t(item.label)}
                variant="outlined"
              />
            </Grid>
          ))}
        </Grid>
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('nrOfDaysForAdditionalCompensation')}>
        <ControlledNumericFieldWithReadMode
          variant="outlined"
          name={'nrOfDaysForAdditionalCompensation'}
          label={t('nrOfDaysForAdditionalCompensation')}
          valueGetter="value"
        />
      </MultiStepForm.Section>
    </div>
  );
};

export default DeviatingTab;
